import { API_PATHS, type InvitePreviewResponse } from '@lunya/contracts'

import { createQuery } from '~/shared/api'

import { mapInvitePreviewFromApi } from './mappers/mapInvitePreviewFromApi'
import type { InvitePreview } from '../types'

// Превью приглашения по токену — нужно экрану B0, чтобы показать имя и пол пригласившего
// ДО принятия приглашения (спека 02 §B0: «{Имя} зовёт тебя в своё созвездие»).
//
// Ручка по правилам ранжирования (docs/domain.md §1) принадлежит будущему слайсу `link`, но
// живёт здесь, пока слайса нет: онбординг блокировать нечем. Контракт при этом уже общий —
// `invitePreviewResponseSchema` в packages/contracts/src/api/invite.ts.
export type InvitePreviewInput = {
  token: string
}

export const InvitePreviewQuery = createQuery<
  InvitePreviewInput,
  InvitePreviewResponse,
  InvitePreview
>({
  key: 'user.invitePreview',
  path: (input) => API_PATHS.invite.preview(input.token),
  transform: mapInvitePreviewFromApi,
  cacheBehavior: 'persistent',
})
